<template>
    <div style="display:flex; flex-direction: column;" :style="{ overflow: selectedData && selectedData.code ? null : 'hidden' }">
        <div>
            <template>
                <div style="position: relative;">
                    <img style="width: 20px; position: absolute; top: 50%; margin-left: 12px; transform: translateY(-50%);" :src="require('@/assets/img/search_new_gray.png')" alt="">
                    <input class="search_region" ref="searchWordInput" style="height:50px; font-size:16px; width: 100%; border: none; border-radius: 4px; outline: none; padding: 12px 15px; padding-left: 42px;" placeholder="지역을 입력하세요" type="text" v-model="searchWord" @keyup="enter($event)">
                </div>
                <!-- <div style="display:grid;place-items: center; width:70px;background-color: var(--color-main); color:white; border-radius:5px; margin-left:5px; height:50px;" @click="searchBefore">검색</div> -->
                <div v-if="!isSearch && Object.keys(selectedData).length === 0" style="color: #606060; font-weight: 400; margin-top: 4px; line-height: 20px; font-size: 12px;">예시 : 서울시 강남구 도곡동</div>
            </template>
            <template v-if="selectedData && selectedData.code">
                <div style="display:flex;align-items:center; justify-content: space-between; border-radius: 4px;padding: 8px 12px; margin-top: 8px; background-color: white;width:100%;" @click="unselect">
                    <div style="color:var(--color-main); font-size: 14px; font-weight: 500; line-height: 24px;">{{ selectedData.sido }} {{ selectedData.sigungu }} {{ selectedData.dong + (selectedData && selectedData.ri ? ' ' + selectedData.ri : '') }}</div>
                    <img style="width: 12px;" :src="require('@/assets/img/search_x_btn.png')" alt="">
                </div>
            </template>
        </div>
        <div style="margin-top: 8px; background-color: #fff; border-radius: 4px;" v-if="isSearch">
            <InfinityScroll :is-enable-next-page-handle="isEnableNextPageHandle" :handle-next-page="handleNextPage" style="border-radius: 4px;" :style="{ height: calcHeight }">
                <div :style="{ paddingTop: i === 0 ? '8px' : '5px' }" v-for="each, i in regions" :key="i" style="display:flex; align-items: center; padding: 6px 8px; background-color: #fff;" @click="select(each)">
                    <div style="flex:1; font-weight: 500; line-height: 24px;" v-html="each.display_str"></div>
                </div>
            </InfinityScroll>
        </div>
    </div>
</template>

<script>
import InfinityScroll from "./InfinityScroll";
import _ from 'lodash';
export default {
    name: "RegionSearchSelectorVer2",
    components: { InfinityScroll },
    props: {
        detectSelect: {
            type: Function,
            default: () => { }
        },
    },
    data() {
        return {
            isEnableNextPageHandle: true,
            regions: [],
            searchWord: '',
            page: 1,
            selectedData: {
                // code : '1234',
                // sido : '부산광역시',
                // sigungu : '연제구'
            },
            isSearch: false,
        }
    },
    computed: {
        calcHeight() {
            if (this.regions.length === 0) {
                return '100%'
            } else {
                return '250px'
            }
        }
    },
    methods: {
        enter() {
            this.searchBefore();
        },
        throttleKeyup: () => { },
        searchBefore() {
            if (this.searchWord !== '') {
                this.page = 1;
                this.regions = [];
                this.throttleKeyup();
            } else {
                this.unselect()
            }
        },
        async search() {
            this.isEnableNextPageHandle = false;

            const searchWord = this.$refs.searchWordInput.value;

            const parameters = {};
            parameters.searchWord = searchWord;
            parameters.page = this.page;
            const res = await this.$Axios.get('/api/region', { params: parameters });
            const regions = res.data.regions;

            for (const each of regions) {
                each.display_str = (each.sido + ' ' + each.sigungu + ' ' + each.dong + (each.ri ? ' ' + each.ri : '')).replace(searchWord, "<span style='color:var(--color-main)'>" + searchWord + "</span>")
            }

            if (regions.length > 0) {
                this.isSearch = true
                this.isEnableNextPageHandle = true;
                this.regions = [...this.regions, ...regions];
            }
        },
        handleNextPage() {
            this.page++;
            this.search();
        },
        select(data) {
            this.regions = [];
            this.isSearch = false;
            this.selectedData = data;
            this.detectSelect(data);
        },
        unselect() {
            this.selectedData = {};
            this.isSearch = false;
            this.searchWord = '';
            this.detectSelect(null);
            this.$nextTick(() => {
                this.$refs.searchWordInput.focus();
            })

        }
    },
    created() {
        this.throttleKeyup = _.debounce(() => {
            this.search();
        }, 500);
    }
}
</script>

<style scoped>
* {
    font-family: var(--global-font-family)
}

.search_region::placeholder {
    color: #bbbbbb;
    font-size: 14px;
    font-weight: 400;
}
</style>